import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=1bbcdced"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbcdced')) {
      api.createRecord('1bbcdced', component.options)
    } else {
      api.reload('1bbcdced', component.options)
    }
    module.hot.accept("./chat.vue?vue&type=template&id=1bbcdced", function () {
      api.rerender('1bbcdced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/conversation-dialog/chat.vue"
export default component.exports